<template>
  <div class="radar-chart-aifv">
    <div class="radar-chart-container">
      <div class="radar-chart-title-container">
        <div class="title">科室发展进度</div>
        <div class="sub-title">（{{ currentDate }}年度数据）</div>
      </div>
      <div class="radar-chart-table">
        <div class="table-item">
          <div class="table-item-container">
            <div class="title-container">
              <div class="icon">
                <img src="../assets/images/home/Department_alfv.png" alt="" />
              </div>
              <div class="title">病例复盘</div>
            </div>
            <div class="data">{{ totalData && totalData.replay }}</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="table-item">
          <div class="table-item-container">
            <div class="title-container">
              <div class="icon">
                <img src="../assets/images/home/Department_terminal.png" alt="" />
              </div>
              <div class="title">模拟器练习</div>
            </div>
            <div class="data">{{ totalData && totalData.practice }}</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="table-item">
          <div class="table-item-container">
            <div class="title-container">
              <div class="icon">
                <img src="../assets/images/home/Department_course.png" alt="" />
              </div>
              <div class="title">课程学习时长</div>
            </div>
            <div class="hour-data">
              <span>{{ totalData && totalData.learnTime }}</span>h
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="table-item longer-item">
          <div class="table-item-container lower-container">
            <div class="title-container">
              <div class="icon">
                <img src="../assets/images/home/Department_alfv.png" alt="" />
              </div>
              <div class="title">AIFV评分</div>
            </div>
            <div class="data">{{ totalData && totalData.score }}</div>
          </div>
          <div class="description">
            超过全省<span>{{ totalData.percent*100 }}</span>%科室
          </div>
        </div>
      </div>
      <RadarChart :initData="initData" :titlePosition="'center'" :isNationwide="false"></RadarChart>
    </div>
  </div>
</template>

<script>
import RadarChart from './RadarChart.vue'
export default {
  name: 'RadarChartAIFV',
  components: {
    RadarChart
  },
  data() {
    return {
    }
  },
  props: {
    initData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    totalData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    currentDate() {
      let date = new Date()
      let year = date.getFullYear()
      if (year) {
        return year
      } else {
        return '2023'
      }
    }
  },
  watch: {
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.radar-chart-aifv {
  width: 351px;
  max-width: 100vw;
  overflow: hidden;
  background-color: #f0f1f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  margin: 8px 0;
  .radar-chart-container {
    width: 351px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    // border-radius: 12px;
    .radar-chart-title-container {
      width: 320px;
      height: 17px;
      line-height: 17px;
      display: flex;
      align-items: center;
      margin: 16px 0 0 16px;
      .title {
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #000000;
        margin-right: 8px;
      }
      .sub-title {
        height: 17px;
        font-size: 10px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #909091;
        line-height: 17px;
      }
    }
    .radar-chart-table {
      width: 351px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .table-item {
        width: 335px;
        height: 58px;
        position: relative;
        .table-item-container {
          width: 335px;
          height: 58px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title-container {
            display: flex;
            align-items: center;
            margin-left: 10px;
            .icon {
              width: 18px;
              height: 18px;
              img {
                width: 18px;
                height: 18px;
              }
            }
            .title {
              height: 17px;
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
            }
          }
          .data {
            height: 14px;
            font-size: 10px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            color: #EB1700;
            line-height: 14px;
            margin-right: 22px;
          }
          .hour-data {
            height: 14px;
            font-size: 10px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            color: #5b5f6a;
            line-height: 14px;
            margin-right: 22px;
            span {
              height: 14px;
              font-size: 10px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #EB1700;
              line-height: 14px;
              margin-right: 3px;
            }
          }
        }
        .lower-container {
          height: 45px;
        }
        .line {
          width: 335px;
          height: 1px;
          background-color: #ececec;
          position: absolute;
          bottom: 0;
        }
        .description {
          margin-left: 30px;
          width: 305px;
          height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
        }
      }
      .longer-item {
        height: 70px;
      }
    }
  }
}
.student-pie {
  width: 351px;
  max-width: 100vw;
  overflow: hidden;
  background-color: #f0f1f6;
  display: flex;
  flex-wrap: wrap;
  .list-view-titel {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    // padding: 20px 15px 16px 15px;
    // flex-wrap: wrap;
    align-content: center;
    position: relative;
    .list-view-vertical {
      width: 4px;
      height: 12px;
      background-color: #fe6a23;
      border: 1px solid #fe6a23;
      border-radius: 2px;
      margin-right: 7px;
    }
    .list-view-subtitel {
      display: flex;
      width: 80px;
      font-size: 15px;
      font-weight: 800;
      color: #1f333f;
      line-height: 15px;
    }
    .list-view-buttonlist {
      width: 220px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-left: 20px;
      .list-view-button {
        display: inline-block;
        width: 40px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        text-align: center;
      }
      .list-view-buttonclick {
        color: #fe6a23;
        display: inline-block;
        width: 40px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        text-align: center;
      }
    }
  }
  .list-view-btop {
    background: #ffffff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    .list-view-buttonlist {
      text-align: center;
      width: 216px;
      .list-view-leftbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        border-left: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        text-align: center;
      }
      .list-view-leftbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-left: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        text-align: center;
      }
      .list-view-midbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #EB1700;
        text-align: center;
      }
      .list-view-midbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border: 1px solid #EB1700;
        text-align: center;
      }
      .list-view-midtwobutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-right: 1px solid #EB1700;
        text-align: center;
      }
      .list-view-midtwobuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-right: 1px solid #EB1700;
        text-align: center;
      }
      .list-view-rightbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-right: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        text-align: center;
      }
      .list-view-rightbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-right: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        text-align: center;
      }
    }
    .list-view-bottom {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 16px 16px 16px 16px;
      flex-wrap: wrap;
      align-content: center;
      position: relative;
      .list-view-tips {
        display: flex;
        justify-content: flex-end;
        width: 319px;
        font-size: 12px;
        font-weight: 500;
        color: #1f333f;
        line-height: 11px;
        .list-view-roundf {
          line-height: 11px;
          display: flex;
          align-items: center;
          .list-view-round {
            width: 7px;
            height: 7px;
            background: #ffffff;
            border-radius: 50%;
            border: 2px solid #EB1700;
            margin-right: 8px;
          }
        }
      }
    }
    .stuPieDomDiv {
      width: 351px;
      height: 441px;
      background: #ffffff;
      .stuPieDom {
        width: 351px;
        height: 441px;
        text-align: center;
        background: #ffffff;
        border-radius: 5px;
      }
    }
  }
  .list-table {
    background-color: #fff;
    margin-top: 8px;
    padding: 0 6px;
    box-sizing: border-box;
    width: 100%;
    .tilte-txt {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #2b2b2b;
      font-weight: 600;
      height: 60px;
      .num {
        font-size: 22px;
        color: #2b2b2b;
        font-weight: bold;
        margin-left: 10px;
      }
    }
    .table-tr {
      display: flex;
      align-items: center;
      height: 32px;
      padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 12px;
      justify-content: space-between;
      &.th {
        background-color: #f0f1f6;
      }
      &.tr {
        height: 14px;
        line-height: 14px;
        margin-bottom: 16px;
      }
      .table-td {
        font-size: 10px;
        color: #2b2b2b;
        font-weight: 400;
        width: 25%;
        &:nth-last-child(1) {
          width: 50px;
        }
        &.table-th {
          font-size: 12px;
        }
      }
    }
  }
}
.tips-view {
  width: 100%;
  height: 47px;
  margin-top: -10px;
  .tips-view-container {
    // width: 319px;
    height: 47px;
    display: flex;
    // align-items: center;
    // margin-left: 65px;
    justify-content: center;
    text-align: center;
    .tips-img {
      width: 14px;
      height: 16px;
      margin-right: 5px;
      line-height: 17px;
      img {
        width: 14px;
        height: 16px;
      }
    }
    .tips-text {
      // width: 36px;
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #EB1700;
      line-height: 17px;
    }
    .tips-content {
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #EB1700;
      line-height: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RadarChartAIFV.vue